export const alerts = {
    methods : {
        showError : function (msg) {
            return this.$ionic.alertController
                .create({
                    cssClass : 'danger',
                    header: 'Error!',
                    message: msg,
                    buttons: [{
                        cssClass: 'danger',
                        text: 'OK',
                        handler: () => {
                            // self.clearMessage();
                        },
                    }],
                })
                .then(a => a.present());
        },
        showConfirm : function (header, msg, callback) {
            return this.$ionic.alertController
                .create({
                    cssClass : 'warning',
                    header: header,
                    message: msg,
                    buttons: [{
                        cssClass: 'secondary',
                        text: 'OK',
                        handler: () => {
                            callback();
                        },
                    },{
                        cssClass: 'primary',
                        text: 'Cancel',
                        handler: () => {
                            console.log('cancel')
                        },
                    }],
                })
                .then(a => a.present())
        },
        showSuccess : function (msg, callback) {
            return this.$ionic.alertController
                .create({
                    cssClass : 'success',
                    header: 'SUCCESS!',
                    message: msg,
                    buttons: [{
                        cssClass: 'success',
                        text: 'OK',
                        handler: () => {
                            callback();
                        },
                    }],
                })
                .then(a => a.present())
        },
        showWarning : function (header, msg, callback) {
            return this.$ionic.alertController
                .create({
                    cssClass : 'warning',
                    header: header,
                    message: msg,
                    buttons: [{
                        cssClass: 'warning',
                        text: 'OK',
                        handler: () => {
                            callback();
                        },
                    }],
                })
                .then(a => a.present())
        }
    }
}